import CurrencyConstants from 'constants/currency';
import CurrencyService from 'services/currency';
import Flux from 'lib/flux';

const CurrencyActions = Flux.createActionCreator({
  changeCurrency(currency) {
    CurrencyService.changeCurrency(currency);
    this.dispatchAction(CurrencyConstants.CURRENCY_UPDATED, currency);
  },
});

// For the old scripts that need to communicate
window.CurrencyActionCreators = CurrencyActions;
export default CurrencyActions;
